// extracted by mini-css-extract-plugin
export default {"redMainLoader":"Loader_redMainLoader__5GLL2","redMainLoader-spin":"Loader_redMainLoader-spin__fLAgc"};